import React, { useState } from "react"
import PropTypes from "prop-types"

import { AppProvider } from "./Context"
import Header from "./Header"
import Main from "./Main"
import Footer from "./Footer"
import EmailCaptureModal from "./EmailCaptureModal"
import Chat from "./Chat"
import Loop from "./Loop"
import ThirdParty from "./ThirdParty"

import "./layout.scss"
import "swiper/css/swiper.css"

const Layout = ({ children, location, navigate }) => {

  const [footerEl, setFooterEl] = useState(null)

  return (
    <AppProvider>
      {location.pathname !== "/" &&
        <Header
          location={location}
          navigate={navigate}
        />
      }
      <Main
        location={location}
        footerEl={footerEl}
      >
        {children}
      </Main>
      <Footer
        location={location}
        setFooterEl={setFooterEl}
      />
      <EmailCaptureModal
        location={location}
      />
      {location.pathname !== "/" &&
        <Chat />
      }
      <Loop
        location={location}
      />
      <ThirdParty />
    </AppProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
